import {http} from "../config/Constantes";

export default class IndicadorService {
    constructor() {}

    findVisaoGeralSolicitacoes(filtro) {
        return http.post("/indicadores/visao-geral-solicitacoes", filtro);
    }

    findQuantidadePercentualSolicitacaoJustificativa(filtro) {
        return http.post("/indicadores/quantidade-percentual-solicitacao-justificativa", filtro);
    }

    findQuantidadePercentualMOTsFaixaRemuneracao(filtro) {
        return http.post("/indicadores/quantidade-percentual-mots-faixa-remuneracao", filtro);
    }

    findQuantidadePercentualSolicitacaoExcecaoDivisaoDepartamento(filtro) {
        return http.post("/indicadores/quantidade-percentual-solicitacao-excecao-divisao-departamento", filtro);
    }

    findSolicitacaoDentroForaPrazo(filtro) {
        return http.post("/indicadores/solicitacao-dentro-fora-prazo", filtro);
    }

    findQuantidadePercentualSolicitacaoForaPrazoDivisaoDepartamento(filtro) {
        return http.post("/indicadores/quantidade-percentual-solicitacao-fora-prazo-divisao-departamento", filtro);
    }

    findCargosMaisContratados10(filtro) {
        return http.post("/indicadores/cargos-mais-contratatos-10", filtro);
    }

    findContratacaoDeterminadoCargoDivisaoDepartamento(filtro) {
        return http.post("/indicadores/contratacao-determinado-cargo-divisao-departamento", filtro);
    }

    findSolicitacaoMensalDivisao(filtro) {
        return http.post("/indicadores/solicitacao-mensal-divisao", filtro);
    }

    findQuantidadePercentualContratacaoProduto(filtro) {
        return http.post("/indicadores/quantidade-percentual-contratacao-produto", filtro);
    }

    findContratacaoProdutoCargo(filtro) {
        return http.post("/indicadores/contratacao-produto-cargo", filtro);
    }

    findClassificacaoMediaAlocacao(filtro) {
        return http.post("/indicadores/classificacao-media-alocacao", filtro);
    }

    findMediaHorasExtrasMOTA(filtro) {
        return http.post("/indicadores/media-horas-extras-mot-a", filtro);
    }

    findMediaHorasExtrasMOTB(filtro) {
        return http.post("/indicadores/media-horas-extras-mot-b", filtro);
    }

    findMediaHorasExtrasMOTC(filtro) {
        return http.post("/indicadores/media-horas-extras-mot-c", filtro);
    }

    findSomatorioHorasExtrasMOTA(filtro) {
        return http.post("/indicadores/somatorio-horas-extras-mot-a", filtro);
    }

    findSomatorioHorasExtrasMOTB(filtro) {
        return http.post("/indicadores/somatorio-horas-extras-mot-b", filtro);
    }

    findSomatorioHorasExtrasMOTC(filtro) {
        return http.post("/indicadores/somatorio-horas-extras-mot-c", filtro);
    }

    findMediaDuracaoContratoMOT(filtro) {
        return http.post("/indicadores/media-duracao-contrato-mot", filtro);
    }

    findQuantidadeMOTFornecedor(filtro) {
        return http.post("/indicadores/quantidade-mot-fornecedor", filtro);
    }

    findQuantidadePercentualMigracaoProduto(filtro) {
        return http.post("/indicadores/quantidade-percentual-migracao-produto", filtro);
    }

    findProrrogacaoMOTRealizada(filtro) {
        return http.post("/indicadores/prorrogacao-mot-realizada", filtro);
    }

    findTempoMedioPreenchimentoVaga(filtro) {
        return http.post("/indicadores/tempo-medio-preenchimento-vaga", filtro);
    }

    findTempoMedioRespostaPool(filtro) {
        return http.post("/indicadores/tempo-medio-resposta-pool", filtro);
    }

    findSolicitacaoNaoAtendidaFornecedor(filtro) {
        return http.post("/indicadores/solicitacao-nao-atendida-fornecedor", filtro);
    }
}
